export const countries = {
  BRAZIL: [-14.235, -51.9253],
  REPUBLIC_OF_IRELAND: [53.4129, -8.2439],
  IRAN: [32.4279, 53.688],
  AUSTRIA: [47.5162, 14.5501],
  GERMANY: [51.1657, 10.4515],
  DENMARK: [56.2639, 9.5018],
  CAMEROON: [3.848, 11.5021],
  CZECH_REPUBLIC: [49.8175, 15.473],
  RUSSIA: [61.524, 105.3188],
  SWEDEN: [60.1282, 18.6435],
  ENGLAND: [52.3555, -1.1743],
  KOREA_REPUBLIC: [35.9078, 127.7669],
  COSTA_RICA: [9.7489, -83.7534],
  EGYPT: [26.8206, 30.8025],
  SPAIN: [40.4637, -3.7492],
  FRANCE: [46.6034, 1.8883],
  ITALY: [41.8719, 12.5674],
  SERBIA: [44.0165, 21.0059],
  COLOMBIA: [4.5709, -74.2973],
  WALES: [52.1307, -3.7837],
  URUGUAY: [-32.5228, -55.7658],
  PERU: [-9.19, -75.0152],
  UKRAINE: [48.3794, 31.1656],
  CROATIA: [45.1, 15.2],
  POLAND: [51.9194, 19.1451],
  NIGERIA: [9.082, 8.6753],
  MEXICO: [23.6345, -102.5528],
  ROMANIA: [45.9432, 24.9668],
  NETHERLANDS: [52.1326, 5.2913],
  GEORGIA: [42.3154, 43.3569],
  SCOTLAND: [56.4907, -4.2026],
  UNITED_STATES: [37.0902, -95.7129],
  ALBANIA: [41.1533, 20.1683],
  HUNGARY: [47.1625, 19.5033],
  BELGIUM: [50.8503, 4.3517],
  ALGERIA: [28.0339, 1.6596],
  ARGENTINA: [-38.4161, -63.6167],
  AUSTRALIA: [-25.2744, 133.7751],
  CANADA: [56.1304, -106.3468],
  CHILE: [-35.6751, -71.543],
  ECUADOR: [-1.8312, -78.1834],
  GREECE: [39.0742, 21.8243],
  IVORY_COAST: [7.54, -5.5471],
  JAPAN: [36.2048, 138.2529],
  MALI: [17.5707, -3.9962],
  MOROCCO: [31.7917, -7.0926],
  NORWAY: [60.472, 8.4689],
  PANAMA: [8.5379, -80.7821],
  PORTUGAL: [39.3999, -8.2245],
  QATAR: [25.3548, 51.1839],
  SENEGAL: [14.4974, -14.4524],
  SLOVAKIA: [48.669, 19.699],
  SOUTH_KOREA: [35.9078, 127.7669],
  SWITZERLAND: [46.8182, 8.2275],
  TUNISIA: [33.8869, 9.5375],
  TURKEY: [38.9637, 35.2433],
  COTE_D_IVOIRE: [7.54, -5.5471],
  PARAGUAY: [-23.4425, -58.4438],
  SAUDI_ARABIA: [23.8859, 45.0792],
  AFGHANISTAN: [33.9391, 67.71],
  ANDORRA: [42.5078, 1.5211],
  ANGOLA: [-11.2027, 17.8739],
  ARMENIA: [40.0691, 45.0382],
  AZERBAIJAN: [40.1431, 47.5769],
  BARBADOS: [13.1939, -59.5432],
  BELARUS: [53.7098, 27.9534],
  BELIZE: [17.1899, -88.4976],
  BENIN: [9.3077, 2.3158],
  BERMUDA: [32.3078, -64.7505],
  BHUTAN: [27.5142, 90.4336],
  BOLIVIA: [-16.2902, -63.5887],
  BULGARIA: [42.7339, 25.4858],
  BURUNDI: [-3.3731, 29.9189],
  CHAD: [15.4542, 18.7322],
  COMOROS: [-11.6455, 43.3333],
  CONGO: [-0.228, 15.8277],
  CUBA: [21.5218, -77.7812],
  CURACAO: [12.1696, -68.99],
  CYPRUS: [35.1264, 33.4299],
  ERITREA: [15.1794, 39.7823],
  ESTONIA: [58.5953, 25.0136],
  ETHIOPIA: [9.145, 40.4897],
  FIJI: [-17.7134, 178.065],
  FINLAND: [61.9241, 25.7482],
  GABON: [-0.8037, 11.6094],
  GAMBIA: [13.4432, -15.3101],
  GHANA: [7.9465, -1.0232],
  GIBRALTAR: [36.1408, -5.3536],
  GRENADA: [12.1165, -61.679],
  GUAM: [13.4443, 144.7937],
  GUATEMALA: [15.7835, -90.2308],
  GUINEA: [9.9456, -9.6966],
  GUYANA: [4.8604, -58.9302],
  HAITI: [18.9712, -72.2852],
  HONDURAS: [13.2, -85.6667],
  ICELAND: [64.9631, -19.0208],
  INDIA: [20.5937, 78.9629],
  INDONESIA: [-0.7893, 113.9213],
  IRAQ: [33.2232, 43.6793],
  ISRAEL: [31.0461, 34.8516],
  JAMAICA: [18.1096, -77.2975],
  JORDAN: [30.5852, 36.2384],
  KAZAKHSTAN: [48.0196, 66.9237],
  KENYA: [-0.0236, 37.9062],
  KOSOVO: [42.6026, 20.902],
  KYRGYZSTAN: [41.2044, 74.7661],
  LATVIA: [56.8796, 24.6032],
  LEBANON: [33.8547, 35.8623],
  LIBERIA: [6.4281, -9.4295],
  LIBYA: [26.3351, 17.2283],
  LITHUANIA: [55.1694, 23.8813],
  LUXEMBOURG: [49.8153, 6.1296],
  MADAGASCAR: [-18.7669, 46.8691],
  MALAWI: [-13.2543, 34.3015],
  MALAYSIA: [4.2105, 101.9758],
  MALTA: [35.9375, 14.3754],
  MAURITANIA: [21.0079, -10.9408],
  MAURITIUS: [-20.3484, 57.5522],
  MOLDOVA: [47.4116, 28.3699],
  MONTENEGRO: [42.7087, 19.3744],
  MONTSERRAT: [16.7425, -62.1874],
  MOZAMBIQUE: [-18.6657, 35.5296],
  NAMIBIA: [-22.9576, 18.4904],
  NIGER: [17.6078, 8.0817],
  PALESTINE: [31.9522, 35.2332],
  PARAGUAY: [-23.4425, -58.4438],
  PHILIPPINES: [12.8797, 121.774],
  SLOVENIA: [46.1512, 14.9955],
  SURINAME: [3.9193, -56.0278],
  SWITZERLAND: [46.8182, 8.2275],
  SYRIA: [34.8021, 38.9968],
  TANZANIA: [-6.369, 34.8888],
  THAILAND: [15.87, 100.9925],
  TOGO: [8.6195, 0.8248],
  TUNISIA: [33.8869, 9.5375],
  TURKEY: [38.9637, 35.2433],
  UGANDA: [1.3733, 32.2903],
  UZBEKISTAN: [41.3775, 64.5853],
  VENEZUELA: [6.4238, -66.5897],
  VIETNAM: [14.0583, 108.2772],
  ZAMBIA: [-13.1339, 27.8493],
  ZIMBABWE: [-19.0154, 29.1549],
  NEW_ZEALAND: [-40.9006, 174.886],
  CHINA_PR: [35.8617, 104.1954],
};